import "core-js/modules/es.array.push.js";
import { defineStore } from "pinia";
import store from "@/store";
export var usecommonStore = defineStore("usecommonStore", () => {
  var activenews = ref('blknews');
  var activeclue = ref('activeclue');
  var activeTags = ref(localStorage.getItem('activeTags') ? JSON.parse(localStorage.getItem('activeTags')) : []);
  var activePmsStatisticsType = ref(1);
  var set_activenews = type => {
    activenews.value = type;
  };
  var set_activeclue = num => {
    activeclue.value = num;
  };
  var SET_ACTIVE_TAGS = tag => {
    activeTags.value.push(tag);
    localStorage.setItem('activeTags', JSON.stringify(activeTags.value));
  };
  var DEL_ACTIVE_TAGS = code => {
    var index = activeTags.value.findIndex(x => x.code == code);
    if (index != -1) {
      activeTags.value.splice(index, 1);
    }
  };
  var CLEAR_ACTIVE_TAGS = () => {
    activeTags.value = [];
    localStorage.removeItem('activeTags');
  };

  // 设置项目管理当前选中tag
  var SetPmsStasticsTag = type => {
    activePmsStatisticsType.value = type;
  };
  return {
    activenews,
    set_activenews,
    activeclue,
    set_activeclue,
    activeTags,
    SET_ACTIVE_TAGS,
    DEL_ACTIVE_TAGS,
    SetPmsStasticsTag,
    activePmsStatisticsType,
    CLEAR_ACTIVE_TAGS
  };
});

// 非setup
export function usecommonStoreHook() {
  return usecommonStore(store);
}